
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nieuws/[slug]",
      function () {
        return require("private-next-pages/nieuws/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nieuws/[slug]"])
      });
    }
  